import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from './reducers/user';
import tableorderReducer from './reducers/tableorder';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
};
  
const rootReducer = combineReducers({
    user: userReducer,
    tableorder: tableorderReducer
});
  
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer : persistedReducer,
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      // }).concat(logger),
    }),
})

export const persistor = persistStore(store);
export default store;